const FontSizesFoundationsZiniaThemes = {
    size_25: '0.25rem',
    size_50: '0.5rem',
    size_100: '0.75rem',
    size_150: '1rem',
    size_200: '1.25rem',
    size_250: '1.5rem',
    size_300: '2rem',
    size_350: '2.5rem',
    size_400: '3rem',
    size_450: '3.5rem',
    size_500: '4.5rem',
    size_550: '6rem',
    size_anchors_menu: '16.75rem',
    size_side_menu_desktop: '16.75rem',
    size_side_menu_tablet: '22.5rem',
    size_side_menu_mobile: '22.5rem',
    size_header: '3.5rem',
    size_cover: '12.5rem',
    size_cover_with_tabs: '12.5rem',
    size_cover_mobile_tablet: '12.5rem',
    size_cover_with_tabs_mobile_tablet: '12.5rem',
    size_menu_top_search: '7.188rem',
    size_modal_icon: '7.5rem',
    // window sizes numbers (px)
    // use only when you need to calculate something with window sizes (e.g. media queries)
    size_25_number_px: 4,
    size_50_number_px: 8,
    size_100_number_px: 12,
    size_150_number_px: 16,
    size_200_number_px: 20,
    size_250_number_px: 24,
    size_300_number_px: 32,
    size_350_number_px: 40,
    size_400_number_px: 48,
    size_450_number_px: 56,
    size_500_number_px: 72,
    size_550_number_px: 96,
    size_menu_top_size_px: 230,
    size_anchors_menu_number_px: 268,
    size_header_number_px: 56,
    size_side_menu_desktop_number_px: 268,
    size_side_menu_tablet_number_px: 360,
    size_side_menu_mobile_number_px: 360,
    size_cover_number_px: 420,
    size_cover_with_tab_number_pxs: 372,
    max_size_image: '68rem',
};
export { FontSizesFoundationsZiniaThemes };
//# sourceMappingURL=font-sizes-foundations.zinia.themes.js.map